
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';

import { sharedState } from '../../../../../../framework/state';
import { getResourcePagingNew, getResourcesNew, postResource } from '../../../../../../framework/client/resource';
import TextAreaField from '../../../../../../framework/fields/TextAreaField.vue';

import { ApplicationResource } from '../../../../../../../common/application/enumeration/ApplicationResource';
import { VehicleContractComment } from '../../../../../../../common/application/model/VehicleContractComment';
import { errorToast, successToast } from '../../../../../service/toast_service';
import ViewVehicleContractComment from './ViewVehicleContractComment.vue';
import ParameterService from '../../../../../service/parameter_service';

@Component({
    components: {
        ValidationObserver,
        ViewVehicleContractComment,
        TextAreaField,
    },
})
export default class VehicleContractComments extends Vue {
    readonly resourceType = ApplicationResource.VEHICLE_CONTRACT_COMMENT;
    parameterService = new ParameterService(this.resourceType);

    @Prop(String) readonly vehicleContractId!: string;
    @Prop(String) readonly customerId!: string;

    shared = sharedState;
    local = {
        newComment: '',
        loading: false,
        total: 0,
        rows: [] as VehicleContractComment[],
        parameters: this.parameterService.get(),
    };

    async mounted() {
        if (this.vehicleContractId) {
            this.local.parameters.vehicleContractId = this.vehicleContractId;
        }

        if (this.customerId && !this.shared.admin) {
            this.local.parameters.customerId = this.customerId;
        }

        await this.loadAsyncData();
    }

    updated() {
        const commentView = this.$refs.comments as Element;
        commentView.scrollTop = commentView.scrollHeight;
    }

    async saveComment() {
        try {
            await postResource<VehicleContractComment>(this.resourceType, {
                id: '',
                created: new Date(),
                modified: new Date(),
                customerId: this.customerId,
                comment: this.local.newComment,
                title: '',
                userId: this.shared.context.userId,
                vehicleContractId: this.vehicleContractId,
            });
            successToast(this, 'message.commentSaved');

            this.local.newComment = '';
            await this.loadAsyncData();
        } catch (error) {
            errorToast(this);
        }
    }

    private async loadAsyncData(): Promise<void> {
        this.local.loading = true;

        const backendParameters = this.parameterService.getBackendParameters();

        if (this.vehicleContractId) {
            backendParameters.set('vehicleContractId', this.vehicleContractId);
        }

        this.local.total = (await getResourcePagingNew(this.resourceType, backendParameters, undefined)).rowCount;

        this.local.rows = [];

        const rows: VehicleContractComment[] = await getResourcesNew<VehicleContractComment>(
            this.resourceType,
            this.local.parameters.page,
            backendParameters,
        );

        rows.forEach((row) => {
            this.local.rows.push(row);
        });

        this.$emit('commentsLoaded', this.local.rows.length);

        this.local.loading = false;
    }
}
